const validateActivityName = (name) => $.ajax({
    url: "/check-unique-activity-name-for-user",
    method: "POST",
    data: {
        activityName: name,
        userId: window.currentUserId,
    },
    dataType: "json",
});

export default validateActivityName;
